import { render, staticRenderFns } from "./CopyToClipboardComponent.vue?vue&type=template&id=7960ff02"
import script from "./CopyToClipboardComponent.vue?vue&type=script&lang=js"
export * from "./CopyToClipboardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports